import React, { useState } from "react";
import './google-play-wait-list.css'
import { Link } from "react-router-dom";
import logo1 from '../../logo1.svg'
import ReactGA from "react-ga4";

const GOOGLE_SCRIPT_URL = process.env.REACT_APP_GOOGLE_SCRIPT_URL;
const API_KEY = process.env.REACT_APP_API_KEY; 


const GooglePlayWaitList = () => {
    const [submitted, setSubmitted] = useState(false);
    const [loading, setLoading] = useState(false);
  
    const handleSubmit = async (e) => {
      e.preventDefault();
      const email = e.target.email.value;
      setLoading(true);
  
      try {
        await fetch(GOOGLE_SCRIPT_URL, {
          method: "POST",
          mode: "no-cors",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({ email, key: API_KEY })
        });
        setSubmitted(true);
        e.target.reset();

        ReactGA.event({
          category: "Waitlist",
          action: "Notify Me submitted",
          label: "Android Page Form"
        });
      } catch (err) {
        alert("Something went wrong. Please try again later.");
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    return(   
    <div className="landing-page1">
      <div className="glass-card ">
      <Link to='/' className="logo-home">  
      <div className="branding horizontal">
            <img src={logo1} alt="PawPlate Logo" className="logo animate-logo" />
            <h1 className="brand-name">PawPlate</h1>
      </div>
      </Link>
        {/* Hero Section */}
        <section className="hero">
          <div className="container text-center">
            <h1 className="hero-title">Coming soon to Android 📱</h1>
            <p className="hero-subtitle">
              We're working on bringing PawPlate to Android so more dogs can get the healthy lives they deserve.
              Be the first to know when it's live.
            </p>
            {submitted ? (
              <p className="success-message">Thanks! You're on the list 🐾</p>
            ) : (
              <form className="cta-form" onSubmit={handleSubmit}>
                <input type="email" name="email" placeholder="Your email address" required disabled={loading} />
                <button type="submit" className="primary-btn1" disabled={loading}>
                  {loading ? "Sending..." : "Notify Me"}
                </button>
              </form>
            )}
          </div>
        </section>

        {/* Feature Preview */}
        <section className="features1 ">
          <div className="container">
            <h2 className="section-heading how">What You'll Get</h2>
            <ul className="features-list">
              <li>✅ Smart calorie recommendations</li>
              <li>✅ Weight tracking & visual analytics</li>
              <li>✅ Food logging for raw, kibble, and home food</li>
              <li>✅ Built for dogs who need a better diet</li>
            </ul>
          </div>
        </section>

        {/* Footer */}
        <footer className="footer ">
          <div className="container">
            <p>© 2025 Opami LLC. All rights reserved.</p>
            <div className="footer-links">
              <a href="/privacy-policy">Privacy Policy</a>
              <a href="/terms-of-use">Terms of Use</a>
              <a href="/contact-us">Contact Us</a>
            </div>
          </div>
        </footer>
      </div>
    </div>

      
    )
}

export default GooglePlayWaitList